import { createStyles, makeStyles } from '@mui/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    container: {
      marginTop: '20px',
      paddingBottom: '10px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      borderRadius: '5px',
      maxHeight: '34vh',
      width: '95%',
      overflowX: 'hidden',
      overflowY: 'auto',
      background: 'white',
      '&::-webkit-scrollbar': {
        width: '2vh',
        backgroundColor: '#F5F5F5'
      },
      '&::-webkit-scrollbar-track': {
        boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.3)`,
        backgroundColor: '#F5F5F5',
        borderRadius: '3px'
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: '3px',
        backgroundImage:
          '-webkit-gradient(linear,left bottom,left top,color-stop(0.44, rgb(122,153,217)),color-stop(0.72, rgb(73,125,189)),color-stop(0.86, rgb(28,58,148)));'
      }
    }
  })
)
